function InstagramComponent ({className}) {
    return (
    <li className={className}>
        <a href={"https://www.instagram.com/sweetwood_flora?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="} target='_blank' rel="noopener noreferrer" className='text-dark'><i className={"bi bi-instagram"}></i></a>
    </li>
    );
}

function FacebookComponent({className}) {
    return (
    <li className={className}>
        <a href={"https://www.facebook.com/profile.php?id=61567251187944"} target='_blank' rel="noopener noreferrer" className='text-dark'><i className={"bi bi-facebook"}></i></a>
    </li>
    );
}

function TwitterComponent({className}) {
    return (
    <li className={className}>
        <a href={"https://x.com/zhong_tian57114"} target='_blank' rel="noopener noreferrer" className='text-dark'><i className={"bi bi-twitter-x"}></i></a>
    </li>
    );
}

function DoordashComponent({className}) {
    return (
    <li className={className}>
        <a href={"https://www.doordash.com/store/sweetwoodflora-katy-32008185/"} target='_blank' rel="noopener noreferrer" className='text-dark'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M23.071 8.409a6.09 6.09 0 0 0-5.396-3.228H.584A.589.589 0 0 0 .17 6.184L3.894 9.93a1.75 1.75 0 0 0 1.242.516h12.049a1.554 1.554 0 1 1 .031 3.108H8.91a.589.589 0 0 0-.415 1.003l3.725 3.747a1.75 1.75 0 0 0 1.242.516h3.757c4.887 0 8.584-5.225 5.852-10.413"/></svg></a>
    </li>
    );
}

export {InstagramComponent, FacebookComponent, TwitterComponent, DoordashComponent};